import React from 'react'
import styled from 'styled-components'

const Button = styled.a`
    height: 25px;
    width: 25px;
    display: flex;
    padding: 0;
    align-items: center;
    justify-content: center;

    font-size: .7rem;
    padding: .2rem .5rem;

    i {
        font-size: .7rem;
        margin: 0;
    }

    &.btn-action {
        height: 44px;
        width: 44px;
        font-size: 1.4rem;
        padding: .6rem;

        i {
            font-size: 1.4rem;
          }
    }
`;

export default function ButtonSquare(props) {
    const {
        onClick = () => false,
        href,
        icon,
        text = '',
        tooltip = false,
        tooltipText = '',
        part = false,
        addClass = '',
        className='btn btn-light btn-sm text-gc-dark-blue js-tooltip',
        jsnav = true
    } = props

    let btnProps = {
        title: tooltipText,
        'data-placement': "bottom",
        'data-tooltip': tooltip ? "tooltip" : "",
        'className': className+' '+addClass
    }

    if(jsnav == true){
        btnProps.className = btnProps.className + ' js-nav'
    }

    if (false === part) {
        btnProps.href = href;
    } else {
        btnProps.className += " get_part_link";
        btnProps.href = '#';
        btnProps['data-target'] = href;
        btnProps['data-part'] = part;
    }
    return (
        <Button
            onClick={onClick}
            {...btnProps}
        >
            {icon} {text}
        </Button>
    );
}